import React, { Component } from "react";
import {
  Input,
  Label,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Row,
  Col,
} from "reactstrap";
import classnames from "classnames";
import axios from "axios";
import { Button } from "reactstrap";

class AddNew extends Component {
  state = {
    activeTab: "1",
    AdvisorEmail: "",
    AdvisorName: "",
    AdvisorPhone: "",
    ChapterName: "",
    Charter: "",
    Comments: "",
    Constitution: "",
    Description: "",
    Email: "",
    Keywords: "",
    KirkContract: "true",
    Name: "",
    RiskMgtDone: "",
    RiskMgtEmail: "",
    RiskMgtName: "",
    RiskMgtPhone: "",
    Size: "",
    Standing: "Good",
    StudentContact: "",
    StudentEmail: "",
    StudentPhone: "",
    FinancialManagerName: "",
    FinancialManagerEmail: "",
    FinancialManagerPhone: "",
    RosterManagerName: "",
    RosterManagerEmail: "",
    RosterManagerPhone: "",
    Type: "",
    URL: "",
  };

  toggle = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  };

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  onRadioButtonChange = (isCurrentYear) => {
    this.setState({ Info: isCurrentYear });
  };

  postNewOrg = () => {
    console.log(Type);
    let AdvisorEmail = this.state.AdvisorEmail;
    let AdvisorName = this.state.AdvisorName;
    let AdvisorPhone = this.state.AdvisorPhone;
    let ChapterName = this.state.ChapterName;
    let Charter = this.state.Charter;
    let Comments = this.state.Comments;
    let Constitution = this.state.Constitution;
    let Description = this.state.Description;
    let Email = this.state.Email;
    let Keywords = this.state.Keywords;
    let KirkContract = this.state.KirkContract;
    let Name = this.state.Name;
    let RiskMgtDone = this.state.RiskMgtDone;
    let RiskMgtEmail = this.state.RiskMgtEmail;
    let RiskMgtName = this.state.RiskMgtName;
    let RiskMgtPhone = this.state.RiskMgtPhone;
    let Size = this.state.Size;
    let Standing = this.state.Standing;
    let StudentContact = this.state.StudentContact;
    let StudentEmail = this.state.StudentEmail;
    let StudentPhone = this.state.StudentPhone;
    let FinancialManagerName = this.state.FinancialManagerName;
    let FinancialManagerEmail = this.state.FinancialManagerEmail;
    let FinancialManagerPhone = this.state.FinancialManagerPhone;
    let RosterManagerName = this.state.RosterManagerName;
    let RosterManagerEmail = this.state.RosterManagerEmail;
    let RosterManagerPhone = this.state.RosterManagerPhone;
    let Type = this.state.Type;
    let URL = this.state.URL;
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    //Request body
    const body = JSON.stringify({
      AdvisorEmail,
      AdvisorName,
      AdvisorPhone,
      ChapterName,
      Charter,
      Comments,
      Constitution,
      Description,
      Email,
      Keywords,
      KirkContract,
      Name,
      RiskMgtDone,
      RiskMgtEmail,
      RiskMgtName,
      RiskMgtPhone,
      Size,
      Standing,
      StudentContact,
      StudentEmail,
      StudentPhone,
      RosterManagerName,
      RosterManagerEmail,
      RosterManagerPhone,
      FinancialManagerName,
      FinancialManagerEmail,
      FinancialManagerPhone,
      Type,
      URL,
    });

    axios.post("/api/orgs/addOrg", body, config).then(() => {
      this.props.getNewOrgsUpdate();
      this.props.toggle();
    });
  };

  render() {
    return (
      <div>
        <Nav tabs>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === "1" })}
              onClick={() => {
                this.toggle("1");
              }}>
              Basics
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === "2" })}
              onClick={() => {
                this.toggle("2");
              }}>
              Contacts
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === "3" })}
              onClick={() => {
                this.toggle("3");
              }}>
              Status
            </NavLink>
          </NavItem>

          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === "4" })}
              onClick={() => {
                this.toggle("4");
              }}>
              Description
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === "5" })}
              onClick={() => {
                this.toggle("5");
              }}>
              Comments
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={this.state.activeTab}>
          <TabPane tabId="1">
            <Row>
              <Col sm="6">
                <Label for="Name">Organization Name:</Label>
                <Input
                  type="text"
                  name="Name"
                  id="Name"
                  value={this.state.Name}
                  onChange={this.onChange}
                />
                <br />
              </Col>
            </Row>
            <Row>
              <Col sm="6">
                <Label for="Chapter">Chapter:</Label>
                <Input
                  type="text"
                  name="ChapterName"
                  id="Chapter"
                  value={this.state.ChapterName}
                  onChange={this.onChange}
                />
                <br />
              </Col>
            </Row>
            <Row>
              <Col sm="6">
                <Label for="Type">Type:</Label>
                <br />
                <select
                  className="form-control"
                  id="Type"
                  name="Type"
                  value={this.state.Type}
                  onChange={this.onChange}>
                  <option value="Academic/Professional">
                    Academic/Professional
                  </option>
                  <option value="Media and Publications">
                    Media and Publications
                  </option>
                  <option value="Cultural/Intercultural/Identity-Based">
                  Cultural/Intercultural/Identity-Based
                  </option>
                  <option value="Fee-Based">Fee-Based</option>
                  <option value="Arts and Entertainment">
                    Arts and Entertainment
                  </option>
                  <option value="Political and Activism">
                    Political and Activism
                  </option>
                  <option value="Fraternity and Sorority Life">Fraternity and Sorority Life</option>
                  <option value="Health and Wellness">
                    Health and Wellness
                  </option>
                  <option value="Honorary">Honorary</option>
                  <option value="Recreational/Sports">
                    Recreational/Sports
                  </option>
                  <option value="Spiritual/Faith-Based">
                    Spiritual/Faith-Based
                  </option>
                  <option value="Residential Living">Residential Living</option>
                  <option value="Service">Service</option>
                  <option value="Special Interest">Special Interest</option>
                  <option value="University Department">
                    University Department
                  </option>
                  <option value="Departmental Student Organizations">
                    Departmental Student Organizations{" "}
                  </option>
                  <option value="Faculty Led Honor Societies">
                    Faculty Led Honor Societies
                  </option>
                  <option value="Social">Social</option>
                  <option value="Environmental/Sustainability">
                    Environmental/Sustainability
                  </option>
                </select>
              </Col>
            </Row>
            <Row>
              <Col sm="6">
                <Label for="URL">URL:</Label>

                <Input
                  type="url"
                  name="URL"
                  id="URL"
                  value={this.state.URL}
                  onChange={this.onChange}
                />

                <br />
              </Col>
            </Row>
            <Row>
              <Col sm="6">
                <Label for="Name">Organization Email:</Label>

                <Input
                  type="email"
                  name="Email"
                  id="Email"
                  value={this.state.Email}
                  onChange={this.onChange}
                />

                <br />
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId="2">
            <Row>
              <Col sm="8">
                <Row>
                  <Col sm="1"></Col>
                  <Col sm="2">
                    <Label for="Student">President</Label>
                  </Col>
                  <Col sm="2">
                    <Label for="Advisor">Advisor</Label>
                  </Col>
                  <Col sm="2">
                    <Label for="RiskMgt">Risk Manager</Label>
                  </Col>
                  <Col sm="2">
                    <Label for="FinancialManager">Financial Manager</Label>
                  </Col>
                  <Col sm="2">
                    <Label for="RosterManager">Roster Manager</Label>
                  </Col>
                </Row>
                <Row>
                  <Col sm="1">Name</Col>
                  <Col sm="2">
                    <Input
                      type="text"
                      name="StudentContact"
                      id="StudentContact"
                      value={this.state.StudentContact}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col sm="2">
                    <Input
                      type="text"
                      name="AdvisorName"
                      id="AdvisorName"
                      value={this.state.AdvisorName}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col sm="2">
                    <Input
                      type="text"
                      name="RiskMgtName"
                      id="RiskMgtName"
                      value={this.state.RiskMgtName}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col sm="2">
                    <Input
                      type="text"
                      name="FinancialManagerName"
                      id="FinancialManagerName"
                      value={
                        this.state.FinancialManagerName
                          ? this.state.FinancialManagerName
                          : ""
                      }
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col sm="2">
                    <Input
                      type="text"
                      name="RosterManagerName"
                      id="RosterManagerName"
                      value={
                        this.state.RosterManagerName
                          ? this.state.RosterManagerName
                          : ""
                      }
                      onChange={this.onChange}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="1">Email</Col>
                  <Col sm="2">
                    <Input
                      type="text"
                      name="StudentEmail"
                      id="StudentEmail"
                      value={this.state.StudentEmail}
                      onChange={this.onChange}
                    />
                  </Col>

                  <Col sm="2">
                    <Input
                      type="text"
                      name="AdvisorEmail"
                      id="AdvisorEmail"
                      value={this.state.AdvisorEmail}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col sm="2">
                    <Input
                      type="text"
                      name="RiskMgtEmail"
                      id="RiskMgtEmail"
                      value={this.state.RiskMgtEmail}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col sm="2">
                    <Input
                      type="text"
                      name="FinancialManagerEmail"
                      id="FinancialManagerEmail"
                      value={
                        this.state.FinancialManagerEmail
                          ? this.state.FinancialManagerEmail
                          : ""
                      }
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col sm="2">
                    <Input
                      type="text"
                      name="RosterManagerEmail"
                      id="RosterManagerEmail"
                      value={
                        this.state.RosterManagerEmail
                          ? this.state.RosterManagerEmail
                          : ""
                      }
                      onChange={this.onChange}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="1">Phone</Col>
                  <Col sm="2">
                    <Input
                      type="text"
                      name="StudentPhone"
                      id="StudentPhone"
                      value={this.state.StudentPhone}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col sm="2">
                    <Input
                      type="text"
                      name="AdvisorPhone"
                      id="AdvisorPhone"
                      value={this.state.AdvisorPhone}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col sm="2">
                    <Input
                      type="text"
                      name="RiskMgtPhone"
                      id="RiskMgtPhone"
                      value={this.state.RiskMgtPhone}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col sm="2">
                    <Input
                      type="text"
                      name="FinancialManagerPhone"
                      id="FinancialManagerPhone"
                      value={
                        this.state.FinancialManagerPhone
                          ? this.state.FinancialManagerPhone
                          : ""
                      }
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col sm="2">
                    <Input
                      type="text"
                      name="RosterManagerPhone"
                      id="RosterManagerPhone"
                      value={
                        this.state.RosterManagerPhone
                          ? this.state.RosterManagerPhone
                          : ""
                      }
                      onChange={this.onChange}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId="3">
            <Row>
              <Col sm="12">
                <Row>
                  <Col sm="2">Standing</Col>
                  <Col sm="10">
                    <div className="mb-3">
                      <input
                        type="radio"
                        name="Standing"
                        id="StandingGood"
                        value="Good"
                        checked={this.state.Standing === "Good"}
                        onChange={this.onChange}
                      />{" "}
                      Nice &nbsp;&nbsp;
                      <input
                        name="Standing"
                        id="StandingBad"
                        type="radio"
                        value="Bad"
                        checked={this.state.Standing === "Bad"}
                        onChange={this.onChange}
                      />{" "}
                      Naughty &nbsp;&nbsp;
                      <input
                        name="Standing"
                        id="StandingChartering"
                        type="radio"
                        value="Chartering"
                        checked={this.state.Standing === "Chartering"}
                        onChange={this.onChange}
                      />{" "}
                      Chartering &nbsp;&nbsp;
                      <input
                        name="Standing"
                        id="StandingProvisional"
                        type="radio"
                        value="Provisional"
                        checked={this.state.Standing === "Provisional"}
                        onChange={this.onChange}
                      />{" "}
                      Provisional &nbsp;&nbsp;
                      <input
                        name="Standing"
                        id="StandingInactive"
                        type="radio"
                        value="Inactive"
                        checked={this.state.Standing === "Inactive"}
                        onChange={this.onChange}
                      />{" "}
                      Inactive
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col sm="3">Kirk Contract</Col>
                  <Col sm="3">
                    <div className="mb-3">
                      <input
                        name="KirkContract"
                        id="KirkContractTrue"
                        type="radio"
                        value="true"
                        defaultChecked={this.state.KirkContract === "true"}
                        onChange={this.onChange}
                      />{" "}
                      <label className="form-check-label">
                        Yes &nbsp;&nbsp;
                      </label>
                      <input
                        name="KirkContract"
                        id="KirkContractFalse"
                        type="radio"
                        value="false"
                        defaultChecked={this.state.KirkContract === "false"}
                        onChange={this.onChange}
                      />{" "}
                      <label className="form-check-label">
                        No &nbsp;&nbsp;
                      </label>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col sm="3">Constitution Date</Col>
                  <Col sm="3">
                    <Input
                      type="text"
                      name="Constitution"
                      id="Constitution"
                      value={this.state.Constitution}
                      onChange={this.onChange}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="3">Charter</Col>
                  <Col sm="3">
                    <Input
                      type="text"
                      name="Charter"
                      id="Charter"
                      value={this.state.Charter}
                      onChange={this.onChange}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="3">Size</Col>
                  <Col sm="3">
                    <Input
                      type="text"
                      name="Size"
                      id="Size"
                      value={this.state.Size}
                      onChange={this.onChange}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </TabPane>

          <TabPane tabId="4">
            <Row>
              <Col sm="12">
                <Label for="Description">Description:</Label>
                <Input
                  type="textarea"
                  name="Description"
                  id="Description"
                  value={this.state.Description}
                  onChange={this.onChange}
                />
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId="5">
            <Row>
              <Col sm="12">
                <Label for="CSI Notes">CSI Notes:</Label>
                <Input
                  type="textarea"
                  name="Comments"
                  id="Comments"
                  value={this.state.Comments}
                  onChange={this.onChange}
                />
                <br />
              </Col>
            </Row>
            <Row>
              <Col sm="12">
                <Label for="Keywords">Search Keywords:</Label>
                <Input
                  type="textarea"
                  name="Keywords"
                  id="Keywords"
                  value={this.state.Keywords}
                  onChange={this.onChange}
                />
                <br />
              </Col>
            </Row>
          </TabPane>
        </TabContent>
        <Button
          color="primary"
          onClick={() => {
            this.postNewOrg();
          }}>
          Save
        </Button>
        <Button className="ml-2" color="danger" onClick={this.props.toggle}>
          Close
        </Button>
      </div>
    );
  }
}

export default AddNew;
